<template>
  <div class="page-help background-image d-flex flex-column" :class="[fullHeight>600?'fill-height':'']">
    <div class="help-title wd-col">
      <div class="help--title-img"></div>
    </div>
    <div class="help-content">
      <span class="mb-md">1、奖品的兑换码已经派送至您的账号中，请前往天翼云盘APP首页→“感恩回馈，签到有礼”活动→“奖品”中查看并使用。</span>
      <span class="mb-md">2、兑换码自派送之日起7日内有效，请尽快兑换；奖品自兑换之日起30日内有效。</span>
      <span class="mb-md">3、兑换流程:</span>
      <span class="mb-md">喜马拉雅儿童月会员</span>
      <span class="mb-md">①　在喜马拉雅儿童版APP→我的→兑换→输入兑换码</span>
      <span class="mb-md">②　每个兑换码只能兑换一次。</span>
      <span class="mb-md">喜马拉雅月会员</span>
      <span class="mb-md">①　在喜马拉雅APP→我的→钱包→兑换码→输入兑换码</span>
      <span class="mb-md">②　每个兑换码只能兑换一次。</span>
      <span class="mb-md">爱奇艺月会员</span>
      <span class="mb-md">①　IOS系统：微信关注“爱奇艺VIP”→回复“激活码”→点开“点击此处”→点击“打开爱奇艺APP”→输入兑换码</span>
      <span class="mb-md">②　安卓系统：在爱奇艺APP→我的→我的VIP会员→立即开通→激活码兑换→输入兑换码</span>
      <span class="mb-md">③　每个兑换码只能兑换一次。</span>
      <span class="mb-md">腾讯视频月会员</span>
      <span class="mb-md">①　在腾讯视频APP→个人中心→视频VIP→兑换VIP/优惠券→输入兑换码</span>
      <span class="mb-md">②　每个兑换码只能兑换一次。</span>
<!--      <span class="mb-md">优酷月会员</span>-->
<!--      <span class="mb-md">①　复制链接→打开浏览器→粘贴链接→登录→输入兑换码</span>-->
<!--      <span class="mb-md copy-content">-->
<!--        <span v-model="copyContent"  id="copy_text" style="word-wrap:break-word;color: #19508a"> {{copyContent}}<br/></span>-->
<!--        <a class="copy bg-primary-deep pl-md pr-md pb-xs round-8" @click="copyUrl"  data-clipboard-target="#copy_text" >复制链接</a>-->
<!--      </span>-->
<!--      <span class="mb-md">②　每个兑换码只能兑换一次。</span>-->
    </div>
    <div class="help-return-btn pb-xxxl">
      <button class="bg-red-deep round-8 pl-lg pr-lg pt-xs pb-sm"  @click="$router.push('/lotto')">返回首页</button>
    </div>
  </div>
</template>

<script>
import Clipboard from "clipboard";

export default {
  name: "Help",
  data(){
    return{
      fullHeight: document.documentElement.clientHeight,
      copyContent:'https://h5.vip.youku.com/active_card?spm=a311a.7996332.0.0.51f13080RvyDSj&sharekey=d945665a0d42e7570aca5703b2ae69375'
    }
  },
  methods:{
    copyUrl(){
      const _this = this
      let clipboard = new Clipboard(".copy");
      clipboard.on("success", function(e) {
        _this.$toast('复制成功')
        clipboard.destroy();
      });
      clipboard.on("error", function(e) {
        _this.$toast.warning('不支持复制')
        clipboard.destroy();
      });
    }
  }
}
</script>

<style lang="scss">
.page-help {
  width: 100%;

  .help-title {
    width: 100%;
    text-align: center;
    padding: 40px 40px 0 40px;
  }

  .help-content {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    padding: 0 24px 24px 24px;
    color: #0f1923;

    .copy {
      color: white;
      font-size: 12px;
    }
  }

  .help-return-btn {
    text-align: center;

    button {
      width: auto;
      border: none;
      color: white;
      font-size: 16px;

      &:active {
        color: #efefef;
        opacity: 0.9;
        box-shadow: 0 2px 2px 2px rgba(#2d8ff5, .15), 0 0 2px 2px rgba(#2d8ff5, .15);
      }
    }
  }
}
</style>
